import * as React from 'react';
import useUserCardContext from '../UseCardContext';

function UserCardName() {
    const { user } = useUserCardContext();
    return (
        <h4>{user.full_name}</h4>
    );
}

export default UserCardName;